import type { OperatorMe } from '../../lib/api/operatorConsole';

interface OperatorInfoCardProps {
  operator: OperatorMe['operator'];
  owner: OperatorMe['owner'];
}

export function OperatorInfoCard({ operator, owner }: OperatorInfoCardProps) {
  return (
    <section
      aria-labelledby="operator-info-heading"
      className="flex flex-col gap-3 rounded-[var(--radius-card,28px)] border border-[var(--ui-stroke-card,#EAEAEB)] bg-[var(--ui-bg-paper,#FFFFFF)] p-6"
    >
      <h2
        id="operator-info-heading"
        className="text-[18px] font-semibold text-[var(--ui-text-primary,#15181E)]"
      >
        {operator.name}
      </h2>
      <dl className="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-2 text-[13px]">
        <dt className="text-[var(--ui-text-subtext,#878B95)]">Code</dt>
        <dd className="font-mono text-[var(--ui-text-primary,#15181E)]">{operator.code}</dd>

        <dt className="text-[var(--ui-text-subtext,#878B95)]">Status</dt>
        <dd className="text-[var(--ui-text-primary,#15181E)]">{operator.status}</dd>

        <dt className="text-[var(--ui-text-subtext,#878B95)]">Default template</dt>
        <dd className="font-mono text-[var(--ui-text-primary,#15181E)]">{operator.default_template}</dd>

        <dt className="text-[var(--ui-text-subtext,#878B95)]">Currency</dt>
        <dd className="text-[var(--ui-text-primary,#15181E)]">{operator.currency ?? '—'}</dd>

        <dt className="text-[var(--ui-text-subtext,#878B95)]">Owner</dt>
        <dd className="text-[var(--ui-text-primary,#15181E)]">{owner.email}</dd>
      </dl>
    </section>
  );
}
